// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { areonNetwork as _areonNetwork } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the areonNetwork chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 463
 * Chain Name: Areon Network
 * Default Block Explorer: https://areonscan.com
 * Default RPC URL: https://mainnet-rpc.areon.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { areonNetwork } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: areonNetwork,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const areonNetwork = createCommon({
	..._areonNetwork,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
